import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Pagination from '../pagination-regular';
import CreatePostButton from '../create-post-button';
import PostListItem from '../post-list-item';
import { changePage } from '../../actions/change-page';
import Loader from '../../components/loader';
import { POSTS_PER_PAGE } from '../../constants/pagination';
import styles from './post-list.scss';

class PostListLarge extends Component {
  constructor(props) {
    super(props);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange = ({ page, buttonType }) => {
    this.props.onPageChange(page);
    this.props.changePage({
      page,
      meta: {
        bi: {
          buttonType,
        },
      },
    });
  };

  renderHeader() {
    const { category, showCreatePostAction, entityCount, page } = this.props;

    if (!showCreatePostAction && entityCount <= POSTS_PER_PAGE) {
      return <div className={styles.largeHeader}/>;
    }

    return (
      <div className={styles.largeHeader}>
        <div className={styles.left}>
          <Pagination
            page={page}
            entityCount={entityCount}
            showPerPage={POSTS_PER_PAGE}
            onChange={this.handlePageChange}
          />
        </div>
        <div className={styles.right}>
          {showCreatePostAction && <CreatePostButton categorySlug={category.slug}/>}
        </div>
      </div>
    );
  }

  renderPosts = () =>
    this.props.posts.map(post =>
      <div key={post._id} className={styles.listItem}>
        <PostListItem type={PostListItem.LARGE} post={post} onLikeClick={this.props.onLikeClick}/>
      </div>
    );

  render() {
    const { isLoading, isLoaded } = this.props;
    return (
      <div className={styles.large}>
        {isLoaded && this.renderHeader()}
        {isLoading ? <Loader/> : this.renderPosts()}
      </div>
    );
  }
}

PostListLarge.propTypes = {
  category: PropTypes.object,
  page: PropTypes.number,
  entityCount: PropTypes.number,
  posts: PropTypes.array.isRequired,
  onLikeClick: PropTypes.func,
  showCreatePostAction: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isLoaded: PropTypes.bool,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage,
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(PostListLarge);



// WEBPACK FOOTER //
// ./app/components/post-list/post-list-large.js